// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"user-summary-info_shadow__30dJ_","name":"user-summary-info_name__WdKvf"};